require('dotenv').config({path:'./.env'}) // load .env file
const environment = process.env;
import store from './store'
const NODE_ENV = store.getters['user/getEnv'];
export var APP_CONFIG = {
    env: NODE_ENV,
    server: {
        uri: NODE_ENV == 'production' ? environment.VUE_APP_PROD_BACKEND_BASE_URL : environment.VUE_APP_DEV_BACKEND_BASE_URL
    },
    web: {
        uri: NODE_ENV == 'production' ? environment.VUE_APP_PROD_FRONTEND_BASE_URL : environment.VUE_APP_DEV_FRONTEND_BASE_URL
    }
}